import * as $runtime from "../runtime.js";
import * as Control$dMonad$dReader$dTrans from "../Control.Monad.Reader.Trans/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Restaumatic$dMenu$dPromotions from "../Restaumatic.Menu.Promotions/index.js";
const runMenuQuery = menu => v => v(menu);
const monadMenuQuery = /* #__PURE__ */ Control$dMonad$dReader$dTrans.monadReaderT(Data$dEither.monadEither);
const menuError = x => v => Data$dEither.$Either("Left", x);
const functorMenuQuery = {
  map: x => v => x$1 => {
    const $0 = v(x$1);
    if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
    if ($0.tag === "Right") { return Data$dEither.$Either("Right", x($0._1)); }
    $runtime.fail();
  }
};
const bindMenuQuery = {
  bind: v => k => r => Data$dEither.bindEither.bind(v(r))(a => k(a)(r)),
  Apply0: () => (
    {
      apply: v => v1 => r => Data$dEither.applyEither.apply(v(r))(v1(r)),
      Functor0: () => (
        {
          map: x => v => x$1 => {
            const $0 = v(x$1);
            if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
            if ($0.tag === "Right") { return Data$dEither.$Either("Right", x($0._1)); }
            $runtime.fail();
          }
        }
      )
    }
  )
};
const askMenu = Data$dEither.Right;
const applyMenuQuery = {
  apply: v => v1 => r => Data$dEither.applyEither.apply(v(r))(v1(r)),
  Functor0: () => (
    {
      map: x => v => x$1 => {
        const $0 = v(x$1);
        if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
        if ($0.tag === "Right") { return Data$dEither.$Either("Right", x($0._1)); }
        $runtime.fail();
      }
    }
  )
};
const applicativeMenuQuery = {
  pure: x => v => Data$dEither.$Either("Right", x),
  Apply0: () => (
    {
      apply: v => v1 => r => Data$dEither.applyEither.apply(v(r))(v1(r)),
      Functor0: () => (
        {
          map: x => v => x$1 => {
            const $0 = v(x$1);
            if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
            if ($0.tag === "Right") { return Data$dEither.$Either("Right", x($0._1)); }
            $runtime.fail();
          }
        }
      )
    }
  )
};
const orError = v => v1 => {
  if (v.tag === "Just") { return applicativeMenuQuery.pure(v._1); }
  if (v.tag === "Nothing") { return menuError(v1()); }
  $runtime.fail();
};
const findFODPromotion = /* #__PURE__ */ (() => bindMenuQuery.bind(Data$dEither.Right)(v => orError(Data$dFoldable.find(Data$dMap$dInternal.foldableMap)(x => {
  const $0 = Restaumatic$dMenu$dPromotions.toEnginePromotion(x);
  if ($0.conditions.tag === "CartPromotion") {
    if ($0.conditions._1.tag === "CartValue") { return false; }
    return $0.conditions._1.tag === "FirstOrder";
  }
  if ($0.conditions.tag === "ProductPromotion") { return false; }
  $runtime.fail();
})(v.promotions))(v1 => "New FOD not found")))();
const findPromotion = id => bindMenuQuery.bind(Data$dEither.Right)(v => orError(Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(id)(v.promotions))(v1 => "New promotion not found: " + Data$dShow.showIntImpl(id)));
export {applicativeMenuQuery, applyMenuQuery, askMenu, bindMenuQuery, findFODPromotion, findPromotion, functorMenuQuery, menuError, monadMenuQuery, orError, runMenuQuery};
